import * as React from 'react';

import DemoBlockedModal from './demoBlockedModal';
import { useDemoAccountContextProvider } from '../../contexts/DemoAccountContextProvider';
import { DateTimePickerInput } from '../../../Shared/index';

type DateTimePickerInputProps = React.ComponentProps<typeof DateTimePickerInput>;

const DemoGuardedDateTimePickerInput: React.FC<DateTimePickerInputProps> = (props) => {
  const { isDemo } = useDemoAccountContextProvider();
  const [showModal, setShowModal] = React.useState(false);

  const handleCloseModal = () => setShowModal(false);

  function handlePointerDownCapture(e: React.PointerEvent<HTMLDivElement>) {
    if (!isDemo) return;
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  }

  function handleKeyDownCapture(e: React.KeyboardEvent<HTMLDivElement>) {
    if (!isDemo || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  }

  return (
    <React.Fragment>
      <div onKeyDownCapture={handleKeyDownCapture} onPointerDownCapture={handlePointerDownCapture}>
        <DateTimePickerInput {...props} />
      </div>
      {showModal && <DemoBlockedModal onClose={handleCloseModal} />}
    </React.Fragment>
  );
};

export default DemoGuardedDateTimePickerInput;
